import { defineMessages } from 'react-intl';

export const visitorMessages = defineMessages({
    activeStays: {
        id: 'active-stays',
        defaultMessage: 'Active stays',
    },
    activeStayFull: {
        id: 'active-stay-full',
        defaultMessage: 'Active stay',
    },
    pastStayFull: {
        id: 'past-stay-full',
        defaultMessage: 'Past stay',
    },
    pastStays: {
        id: 'past-stays',
        defaultMessage: 'Past stays',
    },
    stayId: {
        id: 'stay-id',
        defaultMessage: 'Stay ID',
    },
    visitor: {
        id: 'visitor',
        defaultMessage: 'Visitor',
    },
    visitors: {
        id: 'visitors',
        defaultMessage: 'Visitors',
    },
    identifier: {
        id: 'identifier',
        defaultMessage: 'Identifier',
    },
    identifiers: {
        id: 'identifiers',
        defaultMessage: 'Identifiers',
    },
    owner: {
        id: 'owner',
        defaultMessage: 'Owner',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    manuallyCreated: {
        id: 'manually-created',
        defaultMessage: 'Manually created',
    },
    visitorType: {
        id: 'visitor-type',
        defaultMessage: 'Visitor type',
    },
    parkingZone: {
        id: 'parking-zone',
        defaultMessage: 'Parking zone',
    },
    enteredAt: {
        id: 'entered-at',
        defaultMessage: 'Entered at',
    },
    entryPoint: {
        id: 'entry-point',
        defaultMessage: 'Entry point',
    },
    exitPoint: {
        id: 'exit-point',
        defaultMessage: 'Exit point',
    },
    stay: {
        id: 'stay',
        defaultMessage: 'Stay',
    },
    stays: {
        id: 'stays',
        defaultMessage: 'Stays',
    },
    member: {
        id: 'member',
        defaultMessage: 'Member',
    },
    reservation: {
        id: 'reservation',
        defaultMessage: 'Reservation',
    },
    client: {
        id: 'client',
        defaultMessage: 'Client',
    },
    vip: {
        id: 'vip',
        defaultMessage: 'VIP',
    },
    resident: {
        id: 'resident',
        defaultMessage: 'Resident',
    },
    staff: {
        id: 'staff',
        defaultMessage: 'Staff',
    },
    service: {
        id: 'service',
        defaultMessage: 'Service',
    },
    subscription: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
    sidePanel: {
        id: 'side-panel',
        defaultMessage: 'Details',
    },
    parkingStay: {
        id: 'parking-stay',
        defaultMessage: 'Parking stay',
    },
    overview: {
        id: 'overview',
        defaultMessage: 'Overview',
    },
    periods: {
        id: 'periods',
        defaultMessage: 'Periods',
    },
    active: {
        id: 'active',
        defaultMessage: 'Active',
    },
    additionalIdentifiers: {
        id: 'additional-identifiers',
        defaultMessage: 'Additional identifiers',
    },
    paymentDue: {
        id: 'payment-due',
        defaultMessage: 'Payment due',
    },
    exit: {
        id: 'exit',
        defaultMessage: 'Exit',
    },
    duration: {
        id: 'duration',
        defaultMessage: 'Duration',
    },
    person: {
        id: 'person',
        defaultMessage: 'Person',
    },
    car: {
        id: 'car',
        defaultMessage: 'Vehicle',
    },
    truck: {
        id: 'truck',
        defaultMessage: 'Truck',
    },
    bus: {
        id: 'bus-vehicle',
        defaultMessage: 'Bus',
    },
    specialised: {
        id: 'specialised',
        defaultMessage: 'Specialised',
    },
    period: {
        id: 'period',
        defaultMessage: 'Period',
    },
    start: {
        id: 'start',
        defaultMessage: 'Start',
    },
    end: {
        id: 'end',
        defaultMessage: 'End',
    },
    tariff: {
        id: 'tariff',
        defaultMessage: 'Tariff',
    },
    transit: {
        id: 'transit',
        defaultMessage: 'Transit',
    },
    noPeriods: {
        id: 'no-periods',
        defaultMessage: 'There are no periods',
    },
    enter: {
        id: 'enter',
        defaultMessage: 'Enter',
    },
    noPastStays: {
        id: 'no-past-stays',
        defaultMessage: 'There are no past stays',
    },
    openStayDashboard: {
        id: 'open-stay-dashboard',
        defaultMessage: 'Open stay dashboard',
    },
    pay: {
        id: 'pay',
        defaultMessage: 'Pay',
    },
    exitFromParking: {
        id: 'exit-from-parking',
        defaultMessage: 'Exit from parking',
    },
    exitFromParkingSubtitle: {
        id: 'exit-from-parking-subtitle',
        defaultMessage: 'Exit {client} from parking',
    },
    inParking: {
        id: 'in-parking',
        defaultMessage: 'In parking',
    },
    attributes: {
        id: 'attributes',
        defaultMessage: 'Attributes',
    },
    lastVisit: {
        id: 'last-visit',
        defaultMessage: 'Last visit',
    },
    visits: {
        id: 'visits',
        defaultMessage: 'Visits',
    },
    visitedZones: {
        id: 'visited-zones',
        defaultMessage: 'Visited zones',
    },
    ownerOrIdentifier: {
        id: 'owner-or-identifier',
        defaultMessage: 'Owner, identifier',
    },
    parkingStayDashboard: {
        id: 'parking-stay-dashboard',
        defaultMessage: 'Parking stay dashboard',
    },
    paidOn: {
        id: 'paid-on',
        defaultMessage: 'Paid on',
    },
    paymentWith: {
        id: 'payment-with',
        defaultMessage: 'Payment with',
    },
    stayPeriods: {
        id: 'stay-periods',
        defaultMessage: 'Stay periods',
    },
    gatewayPasses: {
        id: 'gateway-passes',
        defaultMessage: 'Gateway passes',
    },
    payments: {
        id: 'payments',
        defaultMessage: 'Payments',
    },
    amountDue: {
        id: 'amount-due',
        defaultMessage: 'Amount due',
    },
    entry: {
        id: 'entry',
        defaultMessage: 'Entry',
    },
    past: {
        id: 'past',
        defaultMessage: 'Past',
    },
    outsideOfParking: {
        id: 'outside-of-parking',
        defaultMessage: 'Outside of parking',
    },
    passedOn: {
        id: 'passed-on',
        defaultMessage: 'Passed on',
    },
    passId: {
        id: 'pass-id',
        defaultMessage: 'Pass ID',
    },
    gateway: {
        id: 'gateway',
        defaultMessage: 'Gateway',
    },
    entryZone: {
        id: 'entry-zone',
        defaultMessage: 'Entry zone',
    },
    exitZone: {
        id: 'exit-zone',
        defaultMessage: 'Exit zone',
    },
    gatewayPass: {
        id: 'gateway-pass',
        defaultMessage: 'Gateway pass',
    },
    pass: {
        id: 'pass',
        defaultMessage: 'Pass',
    },
    exitAt: {
        id: 'exit-at',
        defaultMessage: 'Exit at',
    },
    pastStay: {
        id: 'past-stay',
        defaultMessage: 'Past',
    },
    activeStay: {
        id: 'active-stay',
        defaultMessage: 'Active',
    },
    activeVisit: {
        id: 'active-visit',
        defaultMessage: 'Active visit',
    },
    periodsPlural: {
        id: 'periods-plural',
        defaultMessage: '{count, plural, one {Period} other {Periods}}',
    },
    activeStaysSearchPlaceholder: {
        id: 'active-stays-search-placeholder',
        defaultMessage: 'stay ID, visitor, identifier, owner',
    },
    exitedAt: {
        id: 'exited-at',
        defaultMessage: 'Exited at',
    },
    notInParking: {
        id: 'not-in-parking',
        defaultMessage: 'Not in parking',
    },
    currentStatus: {
        id: 'current-status',
        defaultMessage: 'Current status',
    },
    stayPeriod: {
        id: 'stay-period',
        defaultMessage: 'Stay period',
    },
    pricingPlan: {
        id: 'pricing-plan',
        defaultMessage: 'Pricing plan',
    },
    access: {
        id: 'access',
        defaultMessage: 'Access',
    },
    number: {
        id: 'number',
        defaultMessage: 'Number',
    },
    time: {
        id: 'time',
        defaultMessage: 'Time',
    },
    zones: {
        id: 'zones',
        defaultMessage: 'Zones',
    },
    multipleZones: {
        id: 'multiple-zones',
        defaultMessage: 'Multiple zones',
    },
    entryTime: {
        id: 'entry-time',
        defaultMessage: 'Entry time',
    },
    exitTime: {
        id: 'exit-time',
        defaultMessage: 'Exit time',
    },
    exitPass: {
        id: 'exit-pass',
        defaultMessage: 'Exit pass',
    },
    entryPass: {
        id: 'entry-pass',
        defaultMessage: 'Entry pass',
    },
    noDataAvailable: {
        id: 'no-data-available',
        defaultMessage: 'No data available',
    },
    custom: {
        id: 'custom',
        defaultMessage: 'Custom',
    },
    paidAmount: {
        id: 'paid-amount',
        defaultMessage: 'Paid amount',
    },
    exitGateway: {
        id: 'exit-gateway',
        defaultMessage: 'Exit gateway',
    },
    openGateway: {
        id: 'open-gateway',
        defaultMessage: 'Open gateway',
    },
    exitFromParkingSuccess: {
        id: 'exit-from-parking-success',
        defaultMessage: 'Successful exit',
    },
    exitFromParkingSuccessDescription: {
        id: 'exit-from-parking-success-description',
        defaultMessage: 'Successful exit for client.',
    },
    activeAsOf: {
        id: 'active-as-of',
        defaultMessage: 'Active as of',
    },
    convertedActiveStaySuccessDescription: {
        id: 'converted-active-stay-success-description',
        defaultMessage: 'The active stay has been successfully converted to a membership.',
    },
    convertedActiveStaySuccess: {
        id: 'converted-active-stay-success',
        defaultMessage: 'Active stay converted',
    },
    convertActiveStay: {
        id: 'convert-active-stay',
        defaultMessage: 'Convert active stay',
    },
    convertActiveStayDescription: {
        id: 'convert-active-stay-description',
        defaultMessage: 'Convert active stay to a membership',
    },
    validatedAmount: {
        id: 'validated-amount',
        defaultMessage: 'Validated amount',
    },
    visit: {
        id: 'visit',
        defaultMessage: 'Visit',
    },
    numberOfHiddenButtons: {
        id: 'number-of-hidden-buttons',
        defaultMessage: '{count} more actions',
    },
    noValidationsApplied: {
        id: 'no-validations-applied',
        defaultMessage: 'No validations applied',
    },
    openDashboard: {
        id: 'open-dashboard',
        defaultMessage: 'Open dashboard',
    },
    remainingAmount: {
        id: 'remaining-amount',
        defaultMessage: 'Remaining amount',
    },
    changePricingPlan: {
        id: 'change-pricing-plan',
        defaultMessage: 'Change pricing plan',
    },
    changePricingPlanDescription: {
        id: 'change-pricing-plan-description',
        defaultMessage: 'Change active stays pricing plan',
    },
    changePricingPlanMessage: {
        id: 'change-pricing-plan-message',
        defaultMessage: 'Pricing plan changed',
    },
    changePricingPlanMessageDescription: {
        id: 'created-pricing-plan-message-description',
        defaultMessage: 'The active stays pricing plan has been successfully changed.',
    },
});
